import FeatureSection from './components/Features';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import LogoCollection from './components/LogoCollection';
import Projects from './components/Projects';
import ScrollFadeIn from './components/ScollFadeIn';
import Testimonials from './components/Testimonials';
import Who from './components/Who';
import Why from './components/Why';
import AppTheme from './shared-theme/AppTheme';


export default function App(props) {
  return (
    <AppTheme {...props}>
      <ScrollFadeIn><Hero /></ScrollFadeIn>
      <div>
        <ScrollFadeIn><LogoCollection /></ScrollFadeIn>
        <ScrollFadeIn><FeatureSection /></ScrollFadeIn>
        <ScrollFadeIn><Who /></ScrollFadeIn>
        <ScrollFadeIn><Highlights /></ScrollFadeIn>
        <ScrollFadeIn><Why /></ScrollFadeIn>
        <ScrollFadeIn><Projects /></ScrollFadeIn>
        <ScrollFadeIn><Testimonials /></ScrollFadeIn>
      </div>
    </AppTheme>
  );
}
